import { t, getFullDateString } from "../../services/formatters";
import { useRiepilogoPage } from "./useRiepilogoPage";
import userIcon from "../../assets/imgs/recap-user-icon.svg";
import calendarIcon from "../../assets/imgs/recap-calendar-icon.svg";
import pinIcon from "../../assets/imgs/recap-pin-icon.svg";
import { useEffect } from "react";
import sha256 from "crypto-js/sha256";
import { useComponentMetric, trackCreateAppointment, trackSpanCreateAppointment, trackSpanSessionEnd } from "../../lib/otel";
import "./RiepilogoPage.css";

export const RiepilogoPage = () => {
    const { read, onShowMapClick } = useRiepilogoPage();

    useComponentMetric("riepilogo");

    // Appuntamento creato: la thank-you page e' il punto in cui il journey si chiude.
    // Niente useSessionTracker qui: riavvierebbe la sessione su un trace nuovo.
    useEffect(() => {
        trackCreateAppointment();
        trackSpanCreateAppointment();
        trackSpanSessionEnd();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let privacy_mtk_consent_string = "";
        let privacy_mtk_consent_array = [];
        // if (read("privacyExtcommoffer") == "1") privacy_mtk_consent_array.push("Dati personali");
        // if (read("privacyOtherservice") == "1") privacy_mtk_consent_array.push("Informativa");
        // if (read("privacyProfilazione") == "1") privacy_mtk_consent_array.push("Societa terze");
        privacy_mtk_consent_string = privacy_mtk_consent_array.join(" - ");

        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: read("ricontattoLuogo") == true && read("ricontattoCf") == true ? "/fa-mps/fissa-appuntamento/thank-you-page-clink" : "/fa-mps/fissa-appuntamento/thank-you-page",
            crmIdentification: read("utenteRiconosciuto") && read("utenteRiconosciuto") == true ? "utente riconosciuto" : "nuovo utente",
            privacy_mtk_consent: privacy_mtk_consent_string,
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            userID: read("contactID"),
            oppID: read("oppID"),
            c_shx: sha256(read("codiceFiscale") || "0").toString(),
            m_shx: sha256(read("email") || "0").toString(),
            p_shx: sha256(read("cellulare") || "0").toString(),
            presa_info: "si",
        });
    }, []);

    return (
        <div id="riepilogo-page">
            <div className={`section page-title-component text-center`}>
                <p>Gentile {read("nome")},</p>
                <br />

                <p>
                    {read("prenotazioneExists") ? "ti ricordiamo che hai già un appuntamento fissato: " : "ti ricordiamo l’appuntamento di "}
                    {getFullDateString(read("dataScelta").data)} alle ore {read("orarioSceltoLabel")} con la Filiale di Banca MPS {read("filialeScelta").nomeFiliale}, {read("filialeScelta").indirizzo}
                    , {read("filialeScelta").citta}.
                </p>

                <br />
                <p>Cordiali saluti</p>
            </div>

            {/* <div className={`section page-title-component text-center`}>
                <h1 className="bold">{t("ti_aspettiamo")}</h1>

                {!read("prenotazioneExists") && <h3>{t("ecco_il_riepilogo")}</h3>}
            </div> */}

            {/* recap */}
            <div className="appointment-recap-component white-box text-center">
                <div className="section">
                    <img src={userIcon} />
                    <h3>
                        {read("nome")} {read("cognome")}
                        <p>{read("email")}</p>
                        <p>{read("cellulare")}</p>
                    </h3>
                </div>
                <div className="section">
                    <img src={calendarIcon} />
                    {read("dataScelta") && read("orarioScelto") && (
                        <h3>
                            {getFullDateString(read("dataScelta").data)} - {read("orarioSceltoLabel")}
                        </h3>
                    )}
                </div>
                <div className="section">
                    <img src={pinIcon} />
                    <h3>
                        {read("filialeScelta").nomeFiliale}

                        <p>{read("filialeScelta").indirizzo}</p>
                    </h3>
                </div>

                <div className="section text-sm text-muted">
                    Orari apertura al pubblico <br />
                    LUN/GIO 08:35-12:55, 14:10-16:15 <br />
                    VEN 08:35-12:55, 14:10-15:45
                </div>

                <div className="section text-sm text-muted" onClick={onShowMapClick}>
                    MOSTRA MAPPA
                </div>
            </div>
        </div>
    );
};
